import { render, staticRenderFns } from "./posterManage.vue?vue&type=template&id=a463e4b8&scoped=true&"
import script from "./posterManage.vue?vue&type=script&lang=js&"
export * from "./posterManage.vue?vue&type=script&lang=js&"
import style0 from "./posterManage.vue?vue&type=style&index=0&id=a463e4b8&scoped=true&lang=scss&"
import style1 from "./posterManage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a463e4b8",
  null
  
)

export default component.exports